import React, { useRef, useState } from 'react';
import { useTranslation } from 'next-i18next'; // https://www.i18next.com/
import Form from 'components/Form';
import Fieldset from 'components/Fieldset';
import FormRow from 'components/FormRow';
import FileUpload from 'components/FileUpload';
import Error from 'components/Error';
import Button from 'components/Button';
import MyCvItem from 'components/MyCvItem';
import EditIcon from 'svg/icon-edit.svg';
import IconAdd from 'svg/icon-add.svg';
import IconCopy from 'svg/icon-copy.svg';

export const ALLOWED_FILE_TYPES = [
  {
    label: '.txt',
    mimeType: '.txt',
  },
  {
    label: '.doc',
    mimeType: '.doc',
  },
  {
    label: '.docx',
    mimeType: '.docx',
  },
  {
    label: '.pdf',
    mimeType: 'application/pdf',
  },
  {
    mimeType: 'application/msword',
  },
  {
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
];

const CreateCvForm = ({
  onInputChange,
  createCvType,
  setCreateCvType,
  typeFileUpload,
  typeCopyPaste,
  inputs,
  uploadCvError,
  loading,
  disabled,
  saving,
  saveError,
  applicantCv,
  isApplicationForm,
}) => {
  const { t } = useTranslation();
  const [fileInput, setFileInput] = useState(useRef());
  const [editCurrentCv, setEditCurrentCv] = useState(false);
  const legendTitle = applicantCv ? t('editCv') : t('curriculumVitae.label');

  return (
    <>
      {!isApplicationForm && (
        <Fieldset title="Overige velden" disabled={saving || disabled}>
          <FormRow
            label={t('desiredPosition.label')}
            placeholder={t('desiredPosition.placeholder')}
            inputType="text"
            name="desiredPosition"
            id="desiredPosition"
            value={inputs.desiredPosition}
            onChange={onInputChange}
            required
          />
          <FormRow
            label={t('positionDescription.label')}
            placeholder={t('positionDescription.placeholder')}
            inputType="textarea"
            name="description"
            id="description"
            value={inputs.description}
            onChange={onInputChange}
            className="c-input-text--large-textarea"
            required
          />
        </Fieldset>
      )}
      {applicantCv && (
        <>
          <h3>{t('curriculumVitae.label')}</h3>
          <MyCvItem cv={applicantCv} extraClasses="u-margin-bottom-base" />
          <div className="o-layout o-layout--align-right">
            <div className="o-layout__cell o-layout__cell--fit">
              <Button
                test="editCv"
                onClick={() => setEditCurrentCv(!editCurrentCv)}
                label={t('editCv')}
                Icon={EditIcon}
                extraClasses={`c-button--small c-button--blue c-button--icon-small${
                  editCurrentCv ? ' u-margin-bottom-base' : ''
                }`}
              />
            </div>
          </div>
        </>
      )}
      {(!applicantCv || editCurrentCv) && (
        <Form saveError={saveError} loading={loading}>
          <Fieldset title={legendTitle} disabled={saving || disabled}>
            <div className="o-layout o-layout--gutter-tiny">
              <div className="o-layout__cell o-layout__cell--fit u-margin-bottom-small">
                <Button
                  label={inputs.cvUpload?.name || t('chooseFile.label')}
                  IconLeft={IconAdd}
                  onClick={() => {
                    setCreateCvType(typeFileUpload);
                    fileInput.click();
                  }}
                  extraClasses="c-button--full-width c-button--file-upload-cta"
                />
              </div>

              <div className="o-layout__cell o-layout__cell--fit u-margin-bottom-small">
                <Button
                  label={t('pasteYourCv.label')}
                  IconLeft={IconCopy}
                  onClick={() => setCreateCvType(typeCopyPaste)}
                  extraClasses="c-button--full-width"
                />
              </div>
            </div>
            <div hidden={createCvType !== typeFileUpload}>
              {uploadCvError && <Error error={uploadCvError} />}
              <FileUpload
                name="cvUpload"
                id="cvUpload"
                test="cvUpload"
                onChange={onInputChange}
                allowedFileTypes={ALLOWED_FILE_TYPES}
                setRef={setFileInput}
                extraClasses="u-margin-bottom-none"
              />
            </div>

            {createCvType === typeCopyPaste && (
              <FormRow
                label={t('pasteYourCv.label')}
                inputType="textarea"
                name="cvContent"
                id="cvContent"
                value={inputs.cvContent}
                onChange={onInputChange}
                extraClasses="u-margin-bottom-none"
                className="c-input-text--large-textarea"
                required
              />
            )}
          </Fieldset>
        </Form>
      )}
    </>
  );
};

export default CreateCvForm;
